import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SupabaseClientService } from '../services/client/supabase-client.service';
import { ConfigurationClientService } from '../services/client/configuration-client.service';
import { OAuthProfileSyncService } from '../services/auth/oauth-profile-sync.service';

@Component({
  selector: 'app-auth-callback',
  template: '<p></p>',
})
export class AuthCallbackComponent implements OnInit {
  constructor(
    private supabaseService: SupabaseClientService,
    private router: Router,
    private config: ConfigurationClientService,
    private oauthSyncService: OAuthProfileSyncService,
  ) {}

  async ngOnInit() {
    try {
      const user = await this.supabaseService.getUser();
      if (user) {
        console.log('AuthCallbackComponent: User signed in:', user);

        // Attempt to sync OAuth profile data if available
        try {
          const profileUpdated = await this.oauthSyncService.syncProfileFromOAuth(user);
          if (profileUpdated) {
            console.log('AuthCallbackComponent: Profile updated from OAuth data');
          }
        } catch (error) {
          // Don't block login flow if profile sync fails
          console.warn('AuthCallbackComponent: Failed to sync OAuth profile data:', error);
        }

        this.router.navigate([this.config.landingRoute]); // Redirect after successful login
      } else {
        console.log('AuthCallbackComponent: User NOT signed in:', user);
        this.router.navigate(['/login']); // Redirect if login failed
      }
    } catch (error) {
      // Handle authentication errors
      console.error('AuthCallbackComponent: Error during authentication:', error);
      this.router.navigate(['/login']); // Redirect to login on authentication error
    }
  }
}
